"use client";

import {
    Sheet,
    SheetContent,
    SheetHeader,
    SheetTrigger
} from "@/components/ui/sheet";
import {
    Tabs,
    TabsContent,
    TabsList,
    TabsTrigger,
} from "@/components/ui/tabs";
import { baseUrl } from "@/util/api/baseUrl";
import { PersianNum } from "@/util/tools/PersianNum";
import { useDebounce } from "@/util/tools/useDebounce";
import { ReloadIcon } from "@radix-ui/react-icons";
import { Search } from "lucide-react";
import Image from "next/image";
import Link from "next/link";
import { useEffect, useState } from "react";

interface TypeSearch {
    status: number;
    message: string;
    data: Data;
}

interface Data {
    original: Product[];
    company: Product[];
    minatory: Product[];
}

interface Product {
    product_title: string;
    product_title_second: string;
    product_url: string;
    product_image: string;
    ProductIdentities: ProductIdentities[];
}

interface Warehouses {
    id: number;
    warehouse_price: number
    warehouse_discount: number
    warehouse_count: number
    warehouse_available: boolean
}
interface ProductIdentities {
    id: number;
    ProductId: number;
    Albums: Album[];
    Warehouses: Warehouses[]
}

interface Album {
    album_image_src: string;
    album_image_alt: string;
    album_image_main: boolean;
}


const SearchHeader = () => {
    const [valueSearch, setValueSearch] = useState<string>("");
    const [loading, setLoading] = useState(false);
    const [listOriginal, setListOriginal] = useState<any>([])
    const [listCompany, setListCompany] = useState<any>([])
    const [listMinatory, setListMinatory] = useState<any>([])

    const value = useDebounce(valueSearch, 500);
    const [open, setOpen] = useState(false)
    useEffect(() => {
        const GetSearch = async () => {
            try {
                setLoading(true);
                const res = await fetch(`${baseUrl}/search-do-search/${value}`);
                const data: TypeSearch = await res.json();
                setLoading(false);
                setListOriginal(data?.data?.original);
                setListCompany(data?.data?.company);
                setListMinatory(data?.data?.minatory);
            } catch (error) {
                console.error("Error fetching search results:", error);
                setLoading(false);
                setListOriginal([]);
                setListCompany([]);
                setListMinatory([]);
            }
        };

        if (value.length > 3) {
            GetSearch();
        } else {
            setListOriginal([]);
            setListCompany([]);
            setListMinatory([]);
        }
    }, [value]);

    const onClose = () => {
        setListOriginal([]);
        setListCompany([]);
        setListMinatory([]);
        setValueSearch("");
        setOpen(!open)
    };

    const loadListSearch = (data: Product[]) => {
        return <div className="sm:flex block flex-wrap overflow-y-auto h-[700px]">
            {
                data?.map((data, index) => {
                    const src = data?.ProductIdentities[0]?.Albums[0]?.album_image_src ? data?.ProductIdentities[0]?.Albums[0]?.album_image_src : data?.product_image
                    return (
                        <Link href={`/product/${data?.product_url.replace(/ /g, "-")}`}
                            key={index}
                            onClick={onClose}
                            className="lg:w-1/4 md:w-1/3 sm:w-1/2 w-full p-2"
                        >
                            <div className="m-2 h-[120px] flex items-center justify-between border rounded-sm  text-center mx-auto relative p-2">
                                <div className="w-[30%]">
                                    <Image
                                        alt={data?.product_title}
                                        src={`${process.env.NEXT_PUBLIC_IMAGE_URL}${src}`}
                                        width={100}
                                        height={100}
                                        className="object-cover rounded-md"
                                        priority
                                        blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mOcvOVYPQAGfQKOiuBnlQAAAABJRU5ErkJggg=="
                                        placeholder="blur"
                                    />
                                </div>
                                <div className="p-1 w-[70%]">
                                    <div className="px-1">
                                        <p className="text-[12px]">{data?.product_title}</p>
                                        <p className="text-[12px]">{data?.product_title_second}</p>
                                        <div className="">
                                            <div className="">
                                                {
                                                    data?.ProductIdentities[0]?.Warehouses[0]?.warehouse_discount ? <p className="text-sm font-bold text-salmon">{PersianNum(data?.ProductIdentities[0]?.Warehouses[0]?.warehouse_discount)}<span className="text-[12px] mr-1">تومان</span> </p> : null
                                                }
                                            </div>
                                            <div className="">
                                                {
                                                    data?.ProductIdentities[0]?.Warehouses[0]?.warehouse_discount ?
                                                        <p className="text-sm line-through text-slate-600">{PersianNum(data?.ProductIdentities[0]?.Warehouses[0]?.warehouse_price)}<span className="text-[12px] mr-1">تومان</span> </p> : <p className="text-sm ">{PersianNum(data?.ProductIdentities[0]?.Warehouses[0]?.warehouse_price)}<span className="text-[12px] mr-1">تومان</span> </p>
                                                }
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Link>
                    )
                })
            }
        </div>
    }

    return (
        <Sheet open={open} onOpenChange={onClose}>
            <SheetTrigger asChild className="">
                <Search aria-label="search" className="text-text1 size-6" />
            </SheetTrigger>
            <SheetContent aria-expanded={open} className="overflow-auto w-full" side="top">
                <SheetHeader>
                    <div className="relative p-10">
                        <input
                            className="border-b-2 block w-full outline-none"
                            placeholder="نام کالای مورد نظر را وارد کنید"
                            value={valueSearch}
                            onChange={(e) => setValueSearch(e.target.value)}
                        />
                        <span className="absolute top-10 left-10">
                            {loading ? (
                                <ReloadIcon aria-hidden="true" className="mr-2 h-4 w-4 animate-spin" />
                            ) : (
                                <Search aria-hidden="true" />
                            )}
                        </span>
                    </div>
                </SheetHeader>
                <Tabs style={{ direction: "rtl" }} defaultValue="اورجینال" className="w-full">
                    <TabsList className="grid w-full grid-cols-3">
                        <TabsTrigger value="اورجینال">اورجینال</TabsTrigger>
                        <TabsTrigger value="شرکتی">شرکتی</TabsTrigger>
                        <TabsTrigger value="مینیاتوری">مینیاتوری</TabsTrigger>
                    </TabsList>
                    <TabsContent value="اورجینال">
                        {loadListSearch(listOriginal)}
                    </TabsContent>
                    <TabsContent value="شرکتی">
                        {loadListSearch(listCompany)}
                    </TabsContent>
                    <TabsContent value="مینیاتوری">
                        {loadListSearch(listMinatory)}
                    </TabsContent>
                </Tabs>
            </SheetContent>
        </Sheet>
    );
};

export default SearchHeader;
